import '#components/complete-the-look'
import '#components/editorial-card'
import '#components/shop-the-look-drawer'
import '#styles/collection.css'

const hasFilterParam = () => {
  const params = new URLSearchParams(window.location.search)

  return [...params.keys()].some((key) => key.startsWith('filter'))
}

const toggleEditorialVisibility = () => {
  document.documentElement.classList.toggle('is-filtering', hasFilterParam())
}

const initializedMobileGalleries = new WeakSet<HTMLElement>()

const updateMobileGalleryDots = (galleryEl: HTMLElement) => {
  const mediaEl = galleryEl.closest<HTMLElement>('.product-card__media')
  const dots = mediaEl?.querySelectorAll<HTMLElement>('.product-card__mobile-gallery-dot')

  if (!mediaEl || !dots?.length || galleryEl.clientWidth === 0) return

  const activeIndex = Math.min(dots.length - 1, Math.max(0, Math.round(galleryEl.scrollLeft / galleryEl.clientWidth)))

  dots.forEach((dot, index) => {
    dot.classList.toggle('is-active', index === activeIndex)
  })
}

const initMobileGalleryDots = (root: ParentNode = document) => {
  root.querySelectorAll<HTMLElement>('.product-card__mobile-gallery').forEach((galleryEl) => {
    if (initializedMobileGalleries.has(galleryEl)) return

    initializedMobileGalleries.add(galleryEl)

    let frame = 0

    galleryEl.addEventListener('scroll', () => {
      cancelAnimationFrame(frame)

      frame = requestAnimationFrame(() => updateMobileGalleryDots(galleryEl))
    })

    updateMobileGalleryDots(galleryEl)
  })
}

const observeMobileGalleries = () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          initMobileGalleryDots(node)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    toggleEditorialVisibility()
    initMobileGalleryDots()
    observeMobileGalleries()
  })
} else {
  toggleEditorialVisibility()
  initMobileGalleryDots()
  observeMobileGalleries()
}

document.addEventListener('facet:update', () => {
  toggleEditorialVisibility()
  initMobileGalleryDots()
})

document.addEventListener('product-card:swatch-updated', (event) => {
  const cardEl = event instanceof CustomEvent && event.detail?.card

  if (cardEl instanceof HTMLElement) {
    initMobileGalleryDots(cardEl)
  }
})
